import { tmrResourceFormController } from 'tmr/controllers/resourceForm/resourceForm'
import templateUrl from './form.html'

/**
 * Xspan add/edit form component.
 *
 * @type {ngComponent}
 */
export const tmrAdminXspanForm = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrAdminXspanFormController',
  bindings: {
    resource: '<',
    toast: '<',
  },
}

/**
 * Controller of component {@link tmrAdminXspanForm}.
 *
 * @type {ngController}
 */
export class tmrAdminXspanFormController extends tmrResourceFormController {
  constructor(
    $scope,
    $state,
    $stateParams,
    TmrInvalidFormError,
    TmrToast,
    tmrProductionWorkflowOperations,
    tmrXspanFieldOfView,
    tmrXspanMode,
    DeviceController,
    Place,
    User,
    Zone
  ) {
    'ngInject'
    super($scope, $state, $stateParams, TmrInvalidFormError, TmrToast)
    Object.assign(this, {
      tmrProductionWorkflowOperations,
      tmrXspanFieldOfView,
      tmrXspanMode,
      DeviceController,
      Place,
      User,
      Zone,
    })
  }

  $onInit() {
    super.$onInit()
    this.operation = this.resource.$getOperation()
  }

  /** Query to get zones for md-autocomplete */
  getZones(value) {
    return this.Zone.search({ 'place.id': this.resource.place.id, value })
      .$promise
  }

  /** Query to get users for md-autocomplete */
  getUsers(value) {
    return this.User.search({ value }).$promise
  }

  /** Query to get places for md-autocomplete */
  getPlaces(value) {
    return this.Place.search({ value }).$promise
  }

  /** Query to get device controllers for md-autocomplete */
  getDeviceControllers(value) {
    return this.DeviceController.search({ value, type: 'XSPAN_MANAGER' })
      .$promise
  }
}
